export default __webpack_public_path__ + "static/media/photo_left_3.427f0ef9.png";